import { Flex, IconButton, Spacer } from '@chakra-ui/react';

import { ArrowLeftIcon } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useListingPageContext } from '../ListingPageContext';
import { OfferScorecardButton, ShareWithClientButton } from './Buttons';
import { DataSource } from './DataSource/DataSource';

export const ListingPageHeader = () => {
  const navigate = useNavigate();
  const { isViewOnly, reportError } = useListingPageContext();

  const handleGoBack = () => navigate(-1);

  return (
    <Flex
      alignItems="center"
      gap={2}
      justifyContent="space-between"
      pt={4}
      px={{ base: 4, md: 10 }}
      width="100%"
    >
      {!isViewOnly && (
        <IconButton
          _hover={{ bg: 'whiteAlpha.300' }}
          aria-label="Go back"
          bg="whiteAlpha.200"
          borderRadius="full"
          color="white"
          h={10}
          icon={<ArrowLeftIcon size={20} />}
          size="sm"
          w={10}
          onClick={handleGoBack}
        />
      )}
      {!reportError && (
        <>
          <DataSource />
          <Spacer />
          <OfferScorecardButton />
          <ShareWithClientButton />
        </>
      )}
    </Flex>
  );
};
